import { useCallback, useState } from 'react';

/**
 * Qual modal de pitch está aberto e para qual pitch.
 * Modal rápido (canetinha): `quickPitchId` null = adicionar um pitch novo.
 * Modal de detalhes: sempre de um pitch existente.
 */
export function usePitchModal() {
  const [quickOpen, setQuickOpen] = useState(false);
  const [quickPitchId, setQuickPitchId] = useState<string | null>(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsPitchId, setDetailsPitchId] = useState<string | null>(null);

  const openQuick = useCallback((pitchId: string | null) => {
    setQuickPitchId(pitchId);
    setQuickOpen(true);
  }, []);
  const closeQuick = useCallback(() => setQuickOpen(false), []);

  const openDetails = useCallback((pitchId: string) => {
    setDetailsPitchId(pitchId);
    setDetailsOpen(true);
  }, []);
  const closeDetails = useCallback(() => setDetailsOpen(false), []);

  return {
    quickOpen,
    quickPitchId,
    openQuick,
    closeQuick,
    detailsOpen,
    detailsPitchId,
    openDetails,
    closeDetails,
  };
}
